/**
 * EB Results Route
 * Component is loaded from route.lazy.tsx for automatic code splitting
 *
 * Authentication is handled by the parent _protected layout route.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/results/eb')({
  // No beforeLoad - parent _protected handles auth
});
